export default __webpack_public_path__ + "static/media/example-code.b2591545.jpg";